(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coweet-product-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(nav) {
      if (nav.dataset.ready) return;
      nav.dataset.ready = '1';
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-coweet-target]'));
      var wrapper = nav.closest('.shopify-section');
      var targets = [];
      function find(id) {
        return document.querySelector('.shopify-section[id$="__' + id + '"], #shopify-section-' + id);
      }
      function refresh() {
        targets = [];
        links.forEach(function (link) {
          var element = find(link.dataset.coweetTarget);
          var visible = element && element.offsetHeight > 24;
          link.parentElement.hidden = !visible;
          if (visible) targets.push({ link: link, element: element });
        });
        nav.hidden = targets.length < 2;
      }
      function headerBottom() {
        var header = document.querySelector('.section-header, #shopify-section-header');
        return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      }
      function update() {
        wrapper.style.setProperty('--coweet-nav-top', headerBottom() + 'px');
        document.documentElement.style.setProperty('--coweet-sticky-bottom', (headerBottom() + (nav.hidden ? 0 : nav.offsetHeight)) + 'px');
        var line = headerBottom() + nav.offsetHeight + 24;
        var active = null;
        targets.forEach(function (item) { if (item.element.getBoundingClientRect().top <= line) active = item.link; });
        links.forEach(function (link) {
          if (link === active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        });
      }
      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var element = find(link.dataset.coweetTarget);
          if (!element) return;
          event.preventDefault();
          var top = element.getBoundingClientRect().top + window.scrollY - nav.offsetHeight - 12;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      });
      var frame = null;
      function schedule() { if (frame === null) frame = requestAnimationFrame(function () { frame = null; update(); }); }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', function () { refresh(); schedule(); });
      window.addEventListener('load', function () { refresh(); schedule(); });
      setTimeout(function () { refresh(); schedule(); }, 1500);
      setTimeout(function () { refresh(); schedule(); }, 4000);
      refresh();
      update();
    }
    function boot() { document.querySelectorAll('[data-coweet-product-nav]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coweet-trust-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coweet-trust-quotes')) {
    customElements.define('coweet-trust-quotes', class extends HTMLElement {
      connectedCallback() {
        var quotes = this.querySelectorAll('.coweet-trust__quote');
        var dots = this.querySelectorAll('.coweet-trust__dots button');
        if (quotes.length < 2) return;
        var index = 0;
        var show = function (next) {
          index = (next + quotes.length) % quotes.length;
          quotes.forEach(function (quote, i) { quote.hidden = i !== index; });
          dots.forEach(function (dot, i) { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        };
        dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); restart(); }); });
        var timer;
        var restart = function () {
          clearInterval(timer);
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { show(index + 1); }, 7000);
        };
        this.addEventListener('mouseenter', function () { clearInterval(timer); });
        this.addEventListener('mouseleave', restart);
        restart();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
